<app-dialog-header
    [title]="this.data.readOnly ? 'Viewing Notes' : 'Edit Notes'"
></app-dialog-header>

<div mat-dialog-content>
    <form [formGroup]="formGroup">
        <mat-form-field class="tw-w-full" appearance="fill">
            <textarea
                cdkTextareaAutosize
                [cdkAutosizeMinRows]="8"
                [formControlName]="data.day"
                matInput
                [maxlength]="maxLength"
                (ngModelChange)="updateCharCount($event)"
                [readonly]="data.readOnly"
                [style.cursor]="cursorStyle"
                style="resize: none"
            ></textarea>
        </mat-form-field>
        <div class="tw-flex tw-justify-end">
            {{ noteCounter }} / {{ maxLength }}
        </div>
    </form>
</div>

@if (this.data.readOnly) {
    <app-dialog-exit (closeClick)="closeDialog()"></app-dialog-exit>
} @else {
    <app-dialog-footer
        (buttonClick)="save()"
        (closeClick)="closeDialog()"
    ></app-dialog-footer>
}
